import React, { useEffect, useState } from "react";
import { pathOr } from "ramda";
import { Box, Button, IconButton, Menu, MenuItem, TableCell, TableRow } from "@mui/material";
import { clone } from "ramda";
import DashboardLayout from "../../layouts/DashboardLayout/DashboardLayout";
import TagsSection from "./TagsSection/TagsSection";
import EquipmentSection from "./EquipmentSection/EquipmentSection";
import { DeleteSharp, BorderColorSharp } from "@mui/icons-material";
import EnrollModal from "./EnrollModal/EnrollModal";
import { http } from "../../../clients/http/http.client";
import { HTTP_ENDPOINTS, WEB_STORAGE_KEYS } from "../../../clients/clients.constants";
import { useDispatch, useSelector } from "react-redux";
import {setEnabledEquipments, setSelectedEquipments, synchronizeEquipments} from "../../../store/euqipmentFiltersSlice";
import { useConfirmationModal } from "../../../services/ConfirmationModalService";
import {DateTime} from "luxon";
import ExportModal from "../../general/ExportModal";
const {
  EQUIPMENT,
  TAGS,
  EQUIPMENT_TYPES,
  DOWNLOAD_EQUIPMENT_REPORT,
  DOWNLOAD_TAGS_REPORT,
  GENERATED_FILE
} = HTTP_ENDPOINTS;

const equipmentColumns = [
  { id: 'type', label: 'TYPE', minWidth: 250 },
  { id: 'number', label: 'NUMBER', minWidth: 150 },
  { id: 'tagType', label: 'TAG TYPE', minWidth: 150 },
  { id: 'tagId', label: 'TAG ID', minWidth: 200 },
  { id: 'siteDescription', label: 'SITE NAME', minWidth: 200 },
];

const initialEquipmentInputs = [
  { label: 'Equipment Type', key: 'equipmentType', options: [] },
  { label: 'Equipment Number', key: 'equipmentNumber', options: [] },
  { label: 'Site ID', key: 'siteId', options: [] },
  { label: 'Tag Type', key: 'tagType', options: [] },
  { label: 'Tag ID', key: 'tagId', options: [] },
];

const initialTagsInputs = [
  { label: 'Tag Type', key: 'tagType', options: [] },
  { label: 'Tag ID', key: 'tagId', options: [] },
];

const EquipmentPage = () => {
  const [isEquipmentLoading, setIsEquipmentLoading] = useState(false);
  const [equipmentOptions, setEquipmentOptions] = useState([]);
  const [equipmentInputs, setEquipmentInputs] = useState(initialEquipmentInputs);
  const [tagsInputs, setTagsInputs] = useState(initialTagsInputs);
  const [processedEquipment, setProcessedEquipment] = useState([]);
  const [processedTags, setProcessedTags] = useState([]);
  const [processedBufferEquipment, setProcessedBufferEquipment] = useState([]);
  const [processedBufferTags, setProcessedBufferTags] = useState([]);
  const [tagsFilterButtonsData, setTagsFilterButtonsData] = useState([]);
  const [enrollingEntity, setEnrollingEntity] = useState({
    tagType: "",
    tagId: "",
    equipmentNumber: '',
    type: '',
    equipmentKey: ''
  });
  const { openModal } = useConfirmationModal();

  const equipmentFilters = useSelector((state) => state.equipmentFilters);
  const siteIdStore = useSelector((state) => state.siteId);

  const [drawerOpen, setDrawerOpen] = useState(true);
  const [selectedEquipment, setSelectedEquipment] = useState([]);
  const [clickedEquipment, setClickedEquipment] = useState(equipmentFilters.equipment.enabledEquipments);
  const [selectedTags, setSelectedTags] = useState([]);
  const [clickedTags, setClickedTags] = useState(equipmentFilters.tag.enabledEquipments);
  const [openEnrollId, setEnrollIdOpen] = useState('');
  const [openMenuId, setOpenMenuId] = useState('');
  const [equipmentTypes, setEquipmentTypes] = useState([]);
  const [tagTypes, setTagTypes] = useState([]);
  const [generatedFiles, setGeneratedFiles] = useState([]);
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user);

  const buildSiteIdQueryParams = () => {
    let params = new URLSearchParams();

    if (siteIdStore.siteId) {
      params.append('siteId', siteIdStore.siteId);
    }

    params.append('withTagIds', true);

    return params.toString() ? `?${params.toString()}` : '';
  };

  const fetchEquipmentData = async () => {
    try {
      let filters = buildSiteIdQueryParams();

      const res = await http.client.get(`${EQUIPMENT}/${filters}`);
      const data = pathOr([], ['data'], res);
      const validIds = data.map(equip => equip.id); // Extract valid equipment IDs
      setProcessedEquipment(data);
      setProcessedBufferEquipment(data);
      // dispatch(synchronizeEquipments({ type: 'equipment', validIds }));
    } catch (error) {
      console.error(error);
    }
  };

  const fetchTagsData = async () => {
    try {
      let filters = buildSiteIdQueryParams();

      const res = await http.client.get(`${TAGS}/${filters}`);
      const data = pathOr([], ['data'], res);
      const validIds = data.map(tag => tag.tagNumber); // Extract valid tag IDs
      setTagsFilterButtonsData(data.map(tag => ({ id: tag.tagNumber, name: tag.tagId })));
      setProcessedTags(data);
      setProcessedBufferTags(data);
      // dispatch(synchronizeEquipments({ type: 'tag', validIds }));
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    const tags = processedBufferTags.filter(tag => {
      const linked = equipmentFilters.tag.linked;
      const unlinked = equipmentFilters.tag.unlinked;
      const search = equipmentFilters.tag.search;
      const enabledTags = equipmentFilters.tag.enabledEquipments;

      const isLinked = !!tag?.equipmentNumber
      const isEnabledIncluded = enabledTags.length ? enabledTags.includes(tag.tagType) : true;
      const isSearchMatch = tag?.equipmentNumber?.toLowerCase()?.includes(search?.toLowerCase()) ||
        tag?.tagId?.toLowerCase()?.includes(search?.toLowerCase()) ||
        tag?.tagType?.toLowerCase()?.includes(search?.toLowerCase());

      const matchesLinkStatus = (isLinked && linked) || (!isLinked && unlinked) || (!linked && !unlinked) || (linked && unlinked);

      return matchesLinkStatus && isEnabledIncluded && isSearchMatch;
    });

    setProcessedTags(tags);

    const equipment = processedBufferEquipment.filter(equip => {
      const linked = equipmentFilters.equipment.linked;
      const unlinked = equipmentFilters.equipment.unlinked;
      const search = equipmentFilters.equipment.search;
      const enabledEquipments = equipmentFilters.equipment.enabledEquipments;

      const isLinked = equip.tags.length > 0;
      const matchesLinkStatus = (isLinked && linked) || (!isLinked && unlinked) || (!linked && !unlinked) || (linked && unlinked);
      const isEnabledIncluded = enabledEquipments.length ? enabledEquipments.includes(equip.type) : true;

      const matchesSearch = !search || (
        equip.number.toLowerCase().includes(search?.toLowerCase()) ||
        equip.type.toLowerCase().includes(search?.toLowerCase()) ||
        equip.tags.some(tag =>
          tag.tagId.toLowerCase().includes(search?.toLowerCase()) ||
          tag.tagType.toLowerCase().includes(search?.toLowerCase())
        )
      );

      return matchesLinkStatus && isEnabledIncluded && matchesSearch;
    });

    localStorage.setItem(WEB_STORAGE_KEYS.EQUIPMENT_FILTERS, JSON.stringify(equipmentFilters));
    setProcessedEquipment(equipment);
  }, [equipmentFilters, processedBufferTags, processedBufferEquipment]);

  useEffect(() => {
    setSelectedEquipment(equipmentFilters.equipment.selectedEquipments);
    setClickedEquipment(equipmentFilters.equipment.enabledEquipments);
    setSelectedTags(equipmentFilters.tag.selectedEquipments);
    setClickedTags(equipmentFilters.tag.enabledEquipments);
  }, [equipmentFilters])

  const fetchEquipmentAndTagsTypes = async () => {
    try {
      let filters = buildSiteIdQueryParams();

      const res = await http.client.get(`${EQUIPMENT_TYPES}/${filters}`);
      const equipmentTypes = pathOr([], ['equipmentTypes'], res);
      const equipmentNumbers = pathOr([], ['equipmentNumbers'], res);
      const tagTypes = pathOr([], ['tagTypes'], res);
      const tagIds = pathOr([], ['tagIds'], res);
      const siteIds = pathOr([], ['siteIds'], res);

      setEquipmentOptions(equipmentNumbers);

      setEquipmentTypes(equipmentTypes);
      setTagTypes(tagTypes);

      setEquipmentInputs((prevState) => {
        return prevState.map((input) => {
          if (input.label === 'Equipment Type') {
            return { ...input, options: equipmentTypes };
          }
          if (input.label === 'Equipment Number') {
            return { ...input, options: equipmentNumbers };
          }
          if (input.label === 'Tag Type') {
            return { ...input, options: tagTypes };
          }
          if (input.label === 'Tag ID') {
            return { ...input, options: tagIds };
          }
          if (input.label === 'Site ID') {
            return { ...input, options: siteIds };
          }
          return input;
        });
      });

      setTagsInputs((prevState) => {
        return prevState.map((input) => {
          if (input.label === 'Tag Type') {
            return { ...input, options: tagTypes };
          }
          if (input.label === 'Tag ID') {
            return { ...input, options: tagIds };
          }
          return input;
        });
      });
    } catch (error) {
      console.error(error)
    }
  };

  const fetchAllData = async () => {
    try {
      setIsEquipmentLoading(true);

      await fetchEquipmentData();
      await fetchTagsData();
      await fetchEquipmentAndTagsTypes();

      setIsEquipmentLoading(false);
    } catch (e) {
      setIsEquipmentLoading(false);
    }
  }

  useEffect(() => {
    fetchAllData();
  }, [siteIdStore.siteId]);

  const handleCloseEnroll = () => {
    setEnrollIdOpen('');
    setEnrollingEntity({
      tagType: "",
      tagId: "",
      equipmentNumber: '',
      type: '',
      equipmentKey: ''
    });
  };

  const handleSubmitEnroll = () => {
    handleCloseEnroll();
  };

  const handleClickedEquipment = (id) => {
    if (clickedEquipment.includes(id)) {
      setClickedEquipment(clickedEquipment.filter(e => e !== id));
    } else {
      setClickedEquipment([...clickedEquipment, id]);
    }
  };

  const clickAllEquipment = () => {
    setClickedEquipment(selectedEquipment)
  };

  const removeAllClickedEquipment = () => {
    setClickedEquipment([]);
  }

  // useEffect(() => {
  //   if (selectedEquipment.length) {
  //     dispatch(setSelectedEquipments({ type: 'equipment', value: selectedEquipment }))
  //   }
  //
  //   clickedEquipment.forEach(e => {
  //     if (!selectedEquipment.includes(e)) {
  //       handleClickedEquipment(e);
  //     }
  //   });
  // }, [selectedEquipment]);
  //
  // useEffect(() => {
  //   if (selectedTags.length) {
  //     dispatch(setSelectedEquipments({ type: 'tag', value: selectedTags }))
  //   }
  //
  //   clickedTags.forEach(e => {
  //     if (!selectedTags.includes(e)) {
  //       handleClickedTags(e);
  //     }
  //   });
  // }, [selectedTags]);

  const handleClickedTags = (id) => {
    if (clickedTags.includes(id)) {
      setClickedTags(clickedTags.filter(e => e !== id));
    } else {
      setClickedTags([...clickedTags, id]);
    }
  };

  const clickAllTags = () => {
    setClickedTags(selectedTags)
  };

  const removeAllClickedTags = () => {
    setClickedTags([]);
  }

  useEffect(() => {
    dispatch(setEnabledEquipments({ type: 'equipment', value: clickedEquipment }))
  }, [clickedEquipment]);

  useEffect(() => {
    dispatch(setEnabledEquipments({ type: 'tag', value: clickedTags }))
  }, [clickedTags]);

  const toggleDrawer = () => {
    setDrawerOpen(!drawerOpen);
  };

  const tagsColumns = [
    { id: 'tagType', label: 'TYPE', minWidth: 120 },
    { id: 'tagId', label: 'TAG ID', minWidth: 250 },
    { id: 'equipmentNumber', label: 'EQUIPMENT', minWidth: 200 },
    { id: 'siteDescription', label: 'SITE NAME', minWidth: 200 },
  ];

  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleOpenMenu = (event, id) => {
    setAnchorEl(event.currentTarget)
    setOpenMenuId(id)
  }

  const handleCloseMenu = () => {
    setAnchorEl(null)
    setOpenMenuId('')
  }

  const EquipmentFixedHeaderContent = () => (
    <TableRow>
      {equipmentColumns.map((column) => (
        <TableCell
          key={column.id}
          sx={{
            width: column.minWidth,
            background: "#fff",
            fontSize: "14px",
            color: '#718096',
            fontWeight: 600
          }}
        >
          {column.label}
        </TableCell>
      ))}
    </TableRow>
  );

  const handleOpenEnroll = (value) => {
    setEnrollIdOpen(value);
    handleCloseMenu()
  };

  const handleUnEnrollTag = async (tagId) => {
    try {
      const res = await http.client.put(HTTP_ENDPOINTS.UN_ENROLL_TAG, { tagId });
      await fetchAllData();
      handleCloseMenu()
    } catch (error) {
      console.log(error);
    }
  };

  const handleDeleteEquipment = async (row) => {
    try {
      const res = await http.client.delete(`${HTTP_ENDPOINTS.DELETE_EQUIPMENT}/${row.id}`);
      await fetchAllData();
    } catch (error) {
      console.log(error);
    }
  };

  const handleDeleteTag = async (row) => {
    try {
      const res = await http.client.delete(`${HTTP_ENDPOINTS.DELETE_TAG}/${row.tagNumber}`);
      await fetchAllData();
    } catch (error) {
      console.log(error);
    }
  };

  const checkGeneratedFile = async (dataType) => {
    try {
      const email = user.user.preferred_username;

      // const dataType = "equipment"; // determine dynamically for now HARDCODED
      const res = await http.client.get(`${GENERATED_FILE}?dataType=${dataType}&email=${encodeURIComponent(email)}`);
      if (res.files && res.files.length > 0) {
        if (dataType === 'equipment') {
          setEquipmentGeneratedFiles(res.files)
        } else {
          setGeneratedFiles(res.files);
        }
      } else {
        setGeneratedFiles([]);
        setEquipmentGeneratedFiles([])
      }
    } catch (error) {
      console.error("Error checking generated file:", error);
      setGeneratedFiles([]);
    }
  };

  // Equipment export state and functions
  const [equipmentExportModalOpen, setEquipmentExportModalOpen] = useState(false);
  const [equipmentExportProgress, setEquipmentExportProgress] = useState(0);
  const [equipmentIsExporting, setEquipmentIsExporting] = useState(false);
  const [equipmentFileGenerationLoading, setEquipmentFileGenerationLoading] = useState(false);
  const [equipmentGeneratedFiles, setEquipmentGeneratedFiles] = useState([]);

  const openEquipmentExportModal = async () => {
    setEquipmentExportModalOpen(true);
    await checkGeneratedFile('equipment')
  };

  const closeEquipmentExportModal = () => {
    setEquipmentExportModalOpen(false);
  };

  const handleEquipmentExport = async (fileType) => {
    console.log('log2');
    const filters = buildSiteIdQueryParams();
    try {
      setEquipmentFileGenerationLoading(true);
      const res = await http.client.get(
          `${DOWNLOAD_EQUIPMENT_REPORT}/${filters}&fileType=${fileType.toLowerCase()}`,
          {
            onDownloadProgress: (progressEvent) => {
              if (progressEvent.total) {
                const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                setEquipmentExportProgress(percentCompleted);
                setEquipmentIsExporting(true);
              }
            }
          }
      );
      setEquipmentExportProgress(100);
    } catch (error) {
      console.error("Equipment export error:", error);
    } finally {
      setEquipmentIsExporting(false);
      setEquipmentFileGenerationLoading(false);
      setEquipmentExportProgress(0);
      await checkGeneratedFile('equipment');
    }
  };

  const [tagsExportModalOpen, setTagsExportModalOpen] = useState(false);
  const [tagsExportProgress, setTagsExportProgress] = useState(0);
  const [tagsIsExporting, setTagsIsExporting] = useState(false);
  const [tagsFileGenerationLoading, setTagsFileGenerationLoading] = useState(false);
  const [tagsGeneratedFiles, setTagsGeneratedFiles] = useState([]);

  const openTagsExportModal = async () => {
    setTagsExportModalOpen(true);
    await checkGeneratedFile('tags');
  };

  const closeTagsExportModal = () => {
    setTagsExportModalOpen(false);
  };

  const handleTagsExport = async (fileType) => {
    const filters = buildSiteIdQueryParams();
    try {
      console.log('log1');
      setTagsFileGenerationLoading(true);
      const res = await http.client.get(
          `${DOWNLOAD_TAGS_REPORT}/${filters}&fileType=${fileType.toLowerCase()}`,
          {
            onDownloadProgress: (progressEvent) => {
              if (progressEvent.total) {
                const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                setTagsExportProgress(percentCompleted);
                setTagsIsExporting(true);
              }
            }
          }
      );
      setTagsExportProgress(100);
    } catch (error) {
      console.error("Tags export error:", error);
    } finally {
      setTagsIsExporting(false);
      setTagsFileGenerationLoading(false);
      setTagsExportProgress(0);
      await checkGeneratedFile('tags');
    }
  };

  const EquipmentTableBodyRowContent = (rowIndex, row) => (
    <>
      <TableCell sx={{padding: '4px 12px'}}>
        <IconButton onClick={() => openModal('Are you sure you want to delete equipment', async () => await handleDeleteEquipment(row))}>
          <DeleteSharp sx={{fontSize: "18px", transform: "translateY(-1px)"}} />
        </IconButton>
        {row.type}
      </TableCell>
      <TableCell sx={{fontSize: "12px", padding: '4px 12px'}}>{row.number}</TableCell>
      <TableCell sx={{fontSize: "12px", padding: '4px 12px'}}>
        {
          row?.tags?.length ? (
            row.tags.map((tag, index) => (
              <Box>
                <div key={index}>
                  <IconButton sx={{ padding: '2px' }} onClick={(event) => handleOpenMenu(event, `${rowIndex}-${index}-equipment`)}>
                    <BorderColorSharp sx={{fontSize: "18px", transform: "translateY(-1px)"}} />
                  </IconButton>
                  {tag.tagType ? tag.tagType : '-'}
                </div>
                <Menu
                  anchorEl={anchorEl}
                  open={openMenuId === `${rowIndex}-${index}-equipment`}
                  onClose={() => handleCloseMenu()}
                  slotProps={{
                    paper: {
                      sx: {
                        boxShadow: "0px 4px 20px 0px #C4D3E7"
                      }
                    }
                  }}
                >
                  <MenuItem sx={{ fontSize: '12px' }} onClick={() => openModal('Are you sure you want to unenroll tag?', async () => await handleUnEnrollTag(tag.tagId))}>
                    <DeleteSharp sx={{fontSize: "18px", transform: "translateY(-1px)"}} />
                    Unenroll Tag
                  </MenuItem>
                  <MenuItem disabled={() => {
                    console.log(row);
                    return row?.tagsLimit === row?.tags?.length
                  }} sx={{ fontSize: '12px' }} onClick={() => handleOpenEnroll(`${rowIndex}-${index}-equipment`)}>
                    + Enroll tag
                  </MenuItem>
                </Menu>
                {
                  openEnrollId === `${rowIndex}-${index}-equipment` && (
                    <EnrollModal
                      type="equipment"
                      open={openEnrollId === `${rowIndex}-${index}-equipment`}
                      handleClose={handleCloseEnroll}
                      row={row}
                      tagsInputs={tagsInputs}
                      setEnrollingEntity={setEnrollingEntity}
                      enrollingEntity={enrollingEntity}
                      tagsList={processedTags}
                      equipmentList={processedEquipment}
                      handleAddEquipmentSuccess={fetchAllData}
                    />
                  )
                }
              </Box>
            )
          )) : (
            <Box>
              <div key={rowIndex}>
                <IconButton sx={{ padding: '2px' }} onClick={(event) => handleOpenMenu(event, `${rowIndex}-equipment`)}>
                  <BorderColorSharp sx={{fontSize: "18px", transform: "translateY(-1px)"}} />
                </IconButton>
                -
              </div>
              <Menu
                anchorEl={anchorEl}
                open={openMenuId === `${rowIndex}-equipment`}
                onClose={() => handleCloseMenu()}
                slotProps={{
                  paper: {
                    sx: {
                      boxShadow: "0px 4px 20px 0px #C4D3E7"
                    }
                  }
                }}
              >
                <MenuItem sx={{ fontSize: '12px' }} disabled>
                  <DeleteSharp sx={{fontSize: "18px", transform: "translateY(-1px)"}} />
                  Unenroll Tag
                </MenuItem>
                <MenuItem sx={{ fontSize: '12px' }} onClick={() => handleOpenEnroll(`${rowIndex}-equipment`)}>
                  + Enroll tag
                </MenuItem>
              </Menu>
              {
                openEnrollId === `${rowIndex}-equipment` && (
                  <EnrollModal
                    type="equipment"
                    open={openEnrollId === `${rowIndex}-equipment`}
                    handleClose={handleCloseEnroll}
                    row={row}
                    tagsInputs={tagsInputs}
                    setEnrollingEntity={setEnrollingEntity}
                    enrollingEntity={enrollingEntity}
                    tagsList={processedTags}
                    equipmentList={processedEquipment}
                    handleAddEquipmentSuccess={fetchAllData}
                  />
                )
              }
            </Box>
          )
        }
      </TableCell>
      <TableCell sx={{fontSize: "12px", padding: '4px 12px'}}>
        {
          row?.tags?.length ? (row.tags.map((tag, i) => <div key={i}>{tag.tagId ? tag.tagId : '-'}</div>)) : '-'
        }
      </TableCell>
      <TableCell sx={{padding: '4px 12px'}}>
        {row?.siteDescription ? row?.siteDescription : '-'}
      </TableCell>
    </>
  );

  const TagsFixedHeaderContent = () => (
    <TableRow>
      {tagsColumns.map((column) => (
        <TableCell
          key={column.id}
          sx={{
            width: column.minWidth,
            background: "#fff",
            fontSize: "14px",
            color: '#718096',
            fontWeight: 600
          }}
        >
          {column.label}
        </TableCell>
      ))}
    </TableRow>
  );

  const TagsTableBodyRowContent = (rowIndex, row) => {
    return (
      <>
        <TableCell sx={{padding: '4px 12px'}}>
          <IconButton disabled={row?.equipmentNumber} onClick={() => openModal("Are you sure you want to delete tag", async () => await handleDeleteTag(row))}>
            <DeleteSharp sx={{fontSize: "18px", transform: "translateY(-1px)"}} />
          </IconButton>
          {row.tagType}
        </TableCell>
        <TableCell sx={{fontSize: "12px", padding: '4px 12px'}}>{row.tagId}</TableCell>
        <TableCell sx={{fontSize: "12px", padding: '4px 12px'}}>
          {
            row.equipmentNumber ? (
              <Box>
                <div>
                  <IconButton sx={{ padding: '2px' }} onClick={(event) => handleOpenMenu(event, `${rowIndex}-tag`)}>
                    <BorderColorSharp sx={{fontSize: "18px", transform: "translateY(-1px)"}} />
                  </IconButton>
                  {row.equipmentNumber ? row.equipmentNumber : '-'}
                </div>
                <Menu
                  anchorEl={anchorEl}
                  open={openMenuId === `${rowIndex}-tag`}
                  onClose={() => handleCloseMenu()}
                  slotProps={{
                    paper: {
                      sx: {
                        boxShadow: "0px 4px 20px 0px #C4D3E7"
                      }
                    }
                  }}
                >
                  <MenuItem sx={{ fontSize: '12px' }} onClick={() => openModal("Are you sure you want to unenroll tag", async () => { await handleUnEnrollTag(row.tagId) }) }>
                    <DeleteSharp sx={{fontSize: "18px", transform: "translateY(-1px)"}} />
                    Unenroll Tag
                  </MenuItem>
                  <MenuItem disabled sx={{ fontSize: '12px' }} onClick={() => handleOpenEnroll(`${rowIndex}-tag`)}>
                    + Enroll tag
                  </MenuItem>
                </Menu>
                {
                  openEnrollId === `${rowIndex}-tag` && (
                    <EnrollModal
                      type="tag"
                      open={openEnrollId === `${rowIndex}-tag`}
                      handleClose={handleCloseEnroll}
                      row={row}
                      equipmentInputs={equipmentInputs}
                      setEnrollingEntity={setEnrollingEntity}
                      enrollingEntity={enrollingEntity}
                      tagsList={processedTags}
                      equipmentList={processedEquipment}
                      handleAddEquipmentSuccess={fetchAllData}
                    />
                  )
                }
              </Box>
            ) : (
              <Box>
                <div key={rowIndex}>
                  <IconButton sx={{ padding: '2px' }} onClick={(event) => handleOpenMenu(event, `${rowIndex}-tag`)}>
                    <BorderColorSharp sx={{fontSize: "18px", transform: "translateY(-1px)"}} />
                  </IconButton>
                  -
                </div>
                <Menu
                  anchorEl={anchorEl}
                  open={openMenuId === `${rowIndex}-tag`}
                  onClose={() => handleCloseMenu()}
                  slotProps={{
                    paper: {
                      sx: {
                        boxShadow: "0px 4px 20px 0px #C4D3E7"
                      }
                    }
                  }}
                >
                  <MenuItem sx={{ fontSize: '12px' }} disabled>
                    <DeleteSharp sx={{fontSize: "18px", transform: "translateY(-1px)"}} />
                    Unenroll Tag
                  </MenuItem>
                  <MenuItem sx={{ fontSize: '12px' }} onClick={() => handleOpenEnroll(`${rowIndex}-tag`)}>
                    + Enroll tag
                  </MenuItem>
                </Menu>
                {
                  openEnrollId === `${rowIndex}-tag` && (
                    <EnrollModal
                      type="tag"
                      open={openEnrollId === `${rowIndex}-tag`}
                      handleClose={handleCloseEnroll}
                      row={row}
                      equipmentInputs={equipmentInputs}
                      setEnrollingEntity={setEnrollingEntity}
                      enrollingEntity={enrollingEntity}
                      tagsList={processedTags}
                      equipmentList={processedEquipment}
                      handleAddEquipmentSuccess={fetchAllData}
                    />
                  )
                }
              </Box>
            )
          }
        </TableCell>
        <TableCell sx={{padding: '4px 12px'}}>
          {row?.siteDescription ? row?.siteDescription : '-'}
        </TableCell>
      </>
    )
  };

  return (
    <DashboardLayout drawerOpen={drawerOpen} toggleDrawer={toggleDrawer}>
      <Box sx={{ gap: "52px", display: "flex", flexDirection: "column" }}>
        {/* Export Modals */}
        <ExportModal
            open={equipmentExportModalOpen}
            onClose={closeEquipmentExportModal}
            fileName={`equipment_export_${Date.now()}`}
            handleDownloadAll={handleEquipmentExport}
            dataType="equipment"
            isMovements={false}
            progress={equipmentExportProgress}
            generatedFiles={equipmentGeneratedFiles}
            fileGenerationLoading={equipmentFileGenerationLoading}
            isExporting={equipmentIsExporting}
        />
        <ExportModal
            open={tagsExportModalOpen}
            onClose={closeTagsExportModal}
            fileName={`tags_export_${Date.now()}`}
            handleDownloadAll={handleTagsExport}
            dataType="tags"
            isMovements={false}
            progress={tagsExportProgress}
            generatedFiles={generatedFiles}
            fileGenerationLoading={tagsFileGenerationLoading}
            isExporting={tagsIsExporting}
        />

        <EquipmentSection
          clickAllEquipment={clickAllEquipment}
          handleClickedEquipment={handleClickedEquipment}
          setSelectedEquipment={setSelectedEquipment}
          clickedEquipment={clickedEquipment}
          removeAllClickedEquipment={removeAllClickedEquipment}
          selectedEquipment={selectedEquipment}
          equipmentsOptions={equipmentTypes}
          fixedHeaderContent={EquipmentFixedHeaderContent}
          tableBodyRowContent={EquipmentTableBodyRowContent}
          processedEquipment={processedEquipment}
          equipmentInputs={equipmentInputs}
          handleSuccessAdd={fetchAllData}
          isEquipmentLoading={isEquipmentLoading}
          openEquipmentExportModal={openEquipmentExportModal}
        />
        <TagsSection
          clickAllTags={clickAllTags}
          handleClickedTags={handleClickedTags}
          setSelectedTags={setSelectedTags}
          clickedTags={clickedTags}
          tagsIds={tagTypes}
          removeAllClickedTags={removeAllClickedTags}
          selectedTags={selectedTags}
          fixedHeaderContent={TagsFixedHeaderContent}
          tableBodyRowContent={TagsTableBodyRowContent}
          processedEquipment={processedTags}
          tagsInputs={tagsInputs}
          handleSuccessAdd={fetchAllData}
          isEquipmentLoading={isEquipmentLoading}
          openTagsExportModal={openTagsExportModal}
        />
      </Box>
    </DashboardLayout>
  );
};

export default EquipmentPage;
